import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { ControlledDto } from 'src/Libs/flow/installation/api'
import { parseEebusChargingStation, parseModbusTcpChargingStation, getEebusPUTDto, getModbusTcpPUTDto } from 'src/Libs/flow/parsers'
import { ChargingPriorityContent } from './ChargingPriorityContent'
import { useEvseChargingPriority } from '../../hooks/use-evse-charging-priority'

type EvChargingPriorityProps = {
  installationId: number
  queryIsLoading: boolean
  evse: Nullable<ControlledDto>
}

export const EvChargingPriority: React.FC<EvChargingPriorityProps> = ({ installationId, queryIsLoading, evse }) => {
  if (evse.media === 'ModbusTCP') {
    return <ModbusTcpChargingPriority installationId={installationId} queryIsLoading={queryIsLoading} evse={evse} />
  }
  if (evse.media === 'EEBus') {
    return <EebusChargingPriority installationId={installationId} queryIsLoading={queryIsLoading} evse={evse} />
  }
  return null
}

const ModbusTcpChargingPriority: React.FC<EvChargingPriorityProps> = ({ installationId, queryIsLoading, evse }) => {
  const { t } = useCustomTranslation()
  const parsedEvse = parseModbusTcpChargingStation(evse)

  const { isPending, handleChargingModeChange, handleSafePvScheduleChange, handleEfficientPvScheduleChange } = useEvseChargingPriority({
    installationId,
    evse: parsedEvse,
    getDtoFn: getModbusTcpPUTDto,
  })

  return (
    <ChargingPriorityContent
      accordionTitle={t('user-settings.evse-page.charging-strategy')}
      currentChargingMode={parsedEvse.chargingMode}
      deviceId={parsedEvse.deviceId}
      safePvSchedule={parsedEvse.safePvSchedule}
      efficientPvSchedule={parsedEvse.efficientPvSchedule}
      isLoading={queryIsLoading || isPending}
      onChargingModeChange={handleChargingModeChange}
      onSafePvScheduleChange={handleSafePvScheduleChange}
      onEfficientPvScheduleChange={handleEfficientPvScheduleChange}
    />
  )
}

const EebusChargingPriority: React.FC<EvChargingPriorityProps> = ({ installationId, queryIsLoading, evse }) => {
  const { t } = useCustomTranslation()
  const parsedEvse = parseEebusChargingStation(evse)

  const { isPending, handleChargingModeChange, handleSafePvScheduleChange, handleEfficientPvScheduleChange } = useEvseChargingPriority({
    installationId,
    evse: parsedEvse,
    getDtoFn: getEebusPUTDto,
  })

  return (
    <ChargingPriorityContent
      accordionTitle={t('user-settings.evse-page.charging-strategy')}
      currentChargingMode={parsedEvse.chargingMode}
      deviceId={parsedEvse.deviceId}
      safePvSchedule={parsedEvse.safePvSchedule}
      efficientPvSchedule={parsedEvse.efficientPvSchedule}
      isLoading={queryIsLoading || isPending}
      onChargingModeChange={handleChargingModeChange}
      onSafePvScheduleChange={handleSafePvScheduleChange}
      onEfficientPvScheduleChange={handleEfficientPvScheduleChange}
    />
  )
}
